import * as swcHelpers from '@swc/helpers';

const getPaymentSelectOptions = (config)=>{
    if (config && 'items' in config && Array.isArray(config.items)) {
        return config.items.reduce((items, item)=>{
            if (item && typeof item.key === 'string' && typeof item.value === 'string') {
                if (item && item.icon) {
                    return swcHelpers.objectSpread({}, items, {
                        [item.value]: {
                            label: item.value,
                            value: item.key,
                            icon: item.icon
                        }
                    });
                }
                return swcHelpers.objectSpread({}, items, {
                    [item.value]: {
                        label: item.value,
                        value: item.key
                    }
                });
            }
            return items;
        }, {});
    }
    return {};
};

export { getPaymentSelectOptions };
//# sourceMappingURL=get-payment-select-options.js.map
